import PropTypes from 'prop-types'

const Resume = ({ width = 24, height = 24, color = '#4A4A4A', ...props }) => (
  <svg
    className="svg-icon"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" />
    <polygon
      points="10 8 16 12 10 16"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

Resume.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}

export default Resume
